/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

import HighchartsVue from "highcharts-vue";

Vue.use(HighchartsVue);

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// API Calls
import "./http/requests";

// Theme Configurations
import "../themeConfig.js";

// Firebase
import "@/firebase/firebaseConfig";

// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);

// ACL
import acl from "./acl/acl";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// i18n
import i18n from "./i18n/i18n";

// Vuexy Admin Filters
import "./filters/filters";

// Clipboard
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// Tour
import VueTour from "vue-tour";
Vue.use(VueTour);
require("vue-tour/dist/vue-tour.css");

// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

// Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
	load: {
		// Add your API key here
		key: "AIzaSyA1PL61F2NGj_GtdZUdE8WtEqqqvTV6eLA",
		libraries: "places,drawing,visualization", // This is required if you use the Auto complete plug-in
		installComponents: true
	}
});
import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues
Vue.component("GmapCluster", GmapCluster);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

import { Dialog, Input, Upload, DatePicker, TimePicker, Progress, Collapse, CollapseItem, Select, Tag, Option, RadioGroup, RadioButton } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Dialog);
Vue.use(Input);
Vue.use(Upload);
Vue.use(Select);
Vue.use(Option);
Vue.use(Progress);
Vue.use(Collapse);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(CollapseItem);
Vue.use(Tag);
Vue.use(RadioGroup);
Vue.use(RadioButton);

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

Vue.use(ElementUI, { locale });

import Inputmask from "inputmask";

Vue.directive("mask", {
	bind: function(el, binding) {
		Inputmask(binding.value).mask(el.getElementsByTagName("INPUT")[0]);
	}
});

// Perfect scrollbar
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
Vue.use(PerfectScrollbar);

import CbsInput from "@/components/cbs-input/CbsInput.vue";
Vue.component(CbsInput.name, CbsInput);

import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";
Vue.component(CbsDatePicker.name, CbsDatePicker);

// Mixins
import mixins from "@/mixins/mixins";
Vue.mixin(mixins);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import constants from "./utils/constants";
import helpers from "./utils/helpers";
import { Validator } from "vee-validate";
import vi from "vee-validate/dist/locale/vi.js";

Validator.localize("vi", vi);

Vue.use({
	install() {
		Vue.helper = helpers;
		Vue.constants = constants;
		Vue.prototype.$helper = helpers;
		Vue.prototype.$constants = constants;
	}
});

// Feather font icon
require("./assets/css/iconfont.css");

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	i18n,
	acl,
	render: h => h(App)
}).$mount("#app");
